
















































import { Utils } from '@/helper/utils';
import { Component } from 'vue-property-decorator';
import { Base } from './base';

@Component({
  props: [
    'url',
    'customerKey',
    'tenantId',
    'enterpriseId',
    'storeId',
    'phoneNumber',
    'firstName',
    'lastName',
    'comments',
    'transactionHeaderId',
    'lastPaymentDetailId',
    'loggedInUserId',
    'loggedInUserEmail',
    'customerEmail',
    'merchantEmail',
    'recordKey',
    'recordIdentifier',
    'type',
    'squareDialog',
    'showTextField',
    'other',
    'selectedCharges',
    'name',
    'account',
    'control',
    'reference',
    'description',
    'lineItems',
    'isAmountOverride',
    'customerName',
  ],
})
export default class SquarePaymentCard extends Base {
  public squareCardUrl: string = Utils.WEB_BASE_URL + '/serverpay/square/card';

  public close() {
    this.$emit('squareDialog', false);
  }
}
